<template>
    <div class="landing-page faqs">
        <!-- Hero banner -->
        <div class="hero-banner">
            <div class="container">
                <h1>Frequently Asked Questions</h1>
            </div>
        </div>

        <!-- FAQ list -->
        <div class="faq-list">
            <!-- Booking questions -->
            <div id="booking-faqs" class="container pb-0">
                <h2>Booking</h2>
                <div class="accordion" role="tablist">
                    <b-card no-body v-for="(bookingFaq, index) in bookingFaqs" :key="index">
                        <b-card-header header-tag="header" role="tab" v-b-toggle="`booking-faq-${index}`">
                            <span v-html="bookingFaq.question"></span>
                        </b-card-header>
                        <b-collapse :id="`booking-faq-${index}`" role="tabpanel" accordion="faq-accordion">
                            <b-card-body>
                                <p v-html="bookingFaq.answer"></p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>

            <!-- Repair questions -->
            <div id="repair-faqs" class="container pb-0">
                <h2>The repair</h2>
                <div class="accordion" role="tablist">
                    <b-card no-body v-for="(repairFaq, index) in repairFaqs" :key="index">
                        <b-card-header header-tag="header" role="tab" v-b-toggle="`repair-faq-${index}`">
                            <span v-html="repairFaq.question"></span>
                        </b-card-header>
                        <b-collapse :id="`repair-faq-${index}`" role="tabpanel" accordion="faq-accordion">
                            <b-card-body>
                                <p v-html="repairFaq.answer"></p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>

            <!-- Guarantee questions -->
            <div id="guarantee-faqs" class="container pb-0">
                <h2>The Likewize Repair guarantee</h2>
                <div class="accordion" role="tablist">
                    <b-card no-body v-for="(guaranteeFaq, index) in guaranteeFaqs" :key="index">
                        <b-card-header header-tag="header" role="tab" v-b-toggle="`guarantee-faq-${index}`">
                            <span v-html="guaranteeFaq.question"></span>
                        </b-card-header>
                        <b-collapse :id="`guarantee-faq-${index}`" role="tabpanel" accordion="faq-accordion">
                            <b-card-body>
                                <p v-html="guaranteeFaq.answer"></p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>

            <!-- Likewize Repair location questions -->
            <div id="wefix-location-faqs" class="container pb-0">
                <h2>Where is Likewize Repair?</h2>
                <div class="accordion" role="tablist">
                    <b-card no-body v-for="(wefixLocationFaq, index) in wefixLocationFaqs" :key="index">
                        <b-card-header header-tag="header" role="tab" v-b-toggle="`wefix-location-faq-${index}`">
                            <span v-html="wefixLocationFaq.question"></span>
                        </b-card-header>
                        <b-collapse :id="`wefix-location-faq-${index}`" role="tabpanel" accordion="faq-accordion">
                            <b-card-body>
                                <p v-html="wefixLocationFaq.answer"></p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>

            <!-- Likewize Repair Terms questions -->
            <div id="wefix-terms-faqs" class="container">
				<h2>The no worries Likewize Repair experience</h2>
                <div class="accordion" role="tablist">
                    <b-card no-body v-for="(wefixTermsFaq, index) in wefixTermsFaqs" :key="index">
                        <b-card-header header-tag="header" role="tab" v-b-toggle="`wefix-terms-faq-${index}`">
                            <span v-html="wefixTermsFaq.question"></span>
                        </b-card-header>
                        <b-collapse :id="`wefix-terms-faq-${index}`" role="tabpanel" accordion="faq-accordion">
                            <b-card-body>
                                <p v-html="wefixTermsFaq.answer"></p>
                            </b-card-body>
                        </b-collapse>
                    </b-card>
                </div>
            </div>

        </div>
    </div>
</template>

<script>
    import { mapGetters} from "vuex"

    export default {
    data() {
        return {
            bookingFaqs: [
                {
                    question: "Can I book multiple repairs?",
                    answer: "Yes. When you get to the basket page, click 'Add another device'."
                },
                {
                    question: "Is it possible to select a specific time for my repair?",
                    answer: "Unfortunately not. You'll be allocated the earliest appointment available. For a same day repair, this will be confirmed at the checkout. For a next day (or later) appointment, the time will be confirmed to you via SMS and email by 08.00am on the day of your repair."
                },
                {
                    question: "Can I change the date of my repair?",
                    answer: "Yes, but we require a minimum of 24 hours notice to cancel your original appointment. Giving less than 24 hours notice will incur a <span v-html='currencySymbol'></span></span>d;59.00 cancellation fee."
                },
                {
                    question: "What happens if I've booked the wrong device?",
                    answer: "If you book the wrong model and/or colour then your Likewize Repair technician won't have the correct spares to carry out your repair. This will incur a <span v-html='currencySymbol'></span></span>d;59.00 cancellation fee and another appointment wil have to be booked."
                },
                {
                    question: "What happens if my device is heavily damaged?",
                    answer: "Contact the Likewize Repair team before you book if you think your device is heavily damaged. Failure to do so may result in your repair not being carried out and a <span v-html='currencySymbol'></span></span>d;59.00 charge being applied."
                },
                {
                    question: "Can I cancel my repair?",
                    answer: "Yes but we require a minimum of 24 hours notice. Giving less than 24 hours notice will incur a <span v-html='currencySymbol'></span></span>d;59.00 cancellation fee."
                },
                {
                    question: "Are there any devices that you do not fix?",
                    answer: "We strive to repair many of the most popular models, however there are unfortunately some we are unable to service. To see if we can repair your device, enter your postcode on the <a href='/'>homepage</a> and follow the steps to select from the list of available models."
                },
            ],
            repairFaqs: [
                {
                    question: "When will you arrive?",
                    answer: "For a same day repair, the time of your appointment will be confirmed at the checkout. For a next day (or later) appointment, the time will be confirmed via SMS and email by 08.00am on the day of your repair.<br /><br />You'll receive a weblink allowing you to track your technician's whereabouts, which should help you get on with your day."
                },
                {
                    question: "How long does it take?",
                    answer: "A standard smartphone screen repair takes approximately thirty minutes. A standard tablet screen repair will take approximately one hour."
                },
                {
                    question: "What do you mean by a one-hour window?",
                    answer: "Likewize Repair promises to arrive within sixty minutes of the allocated time.<br /><br />You'll receive a weblink allowing you to track your technician's whereabouts, which should help you get on with your day."
                },
                {
                    question: "Where is the repair carried out?",
                    answer: "All work is carried out in the Likewize Repair mobile lab-tech workshops, which are Samsung approved."
                },
                {
                    question: "Will the Likewize Repair technician need to come into my home or workplace?",
                    answer: "No. All work is carried out in the Likewize Repair mobile manufacturer-approved, lab-tech workshops."
                },
				{
					question: "What if parking is not available? Does the appointment get cancelled?",
					answer: "Parking is essential which is why we make this clear in all our correspondence. If we arrive and parking is not available, the appointment will unfortunately have to be cancelled and a <span v-html='currencySymbol'></span></span>d;59.00 call-out fee applied."
				},
				{
					question: "Who pays for parking if required?",
					answer: "Any parking charges will be paid for by Likewize Repair."
				},
                {
                    question: "I'm going to be late – will the engineer wait?",
                    answer: "Your Likewize Repair engineer will wait for up to 15 minutes after which time the appointment will be cancelled and a <span v-html='currencySymbol'></span></span>d;59.00 charge applied."
                },
            ],
            guaranteeFaqs: [
                {
                    question: "How long is the Likewize Repair guarantee?",
                    answer: "All Likewize Repair repairs are guaranteed for twelve months from the date they are undertaken. The guarantee is 100% no-quibble."
                },
                {
                    question: "What does the guarantee cover?",
                    answer: "It covers the specific fault that Likewize Repair repaired."
                },
                {
                    question: "How do I claim under the guarantee?",
                    answer: "Email your name, address and details of your device to <a href='mailto:contact@wefix.co.uk'>contact@wefix.co.uk</a> and we'll get things sorted."
                },
            ],
            wefixLocationFaqs: [
                {
                    question: "Is there a Likewize Repair mobile workshop where I am?",
					answer: "There are Likewize Repair mobile workshops all over the UK*. Use the postcode checker on the <a href='/'>homepage</a> to find out if there's one near you.<br /><br /><small>* Service available across the United Kingdom subject to postcode</small>"
                },
                {
                    question: "Where does Likewize Repair live?",
                    answer: "The Likewize Repair central office is in Maldon in Essex. The address is Unit 8 Wyke Hill Business Park, Wyke Hill, Maldon, Essex, CM9 6UZ"
                },
            ],
            wefixTermsFaqs: [
                {
                    question: "Can I see the Likewize Repair Terms &amp; Conditions?",
                    answer: "You'll find the Likewize Repair Terms & Conditions <a href='/terms' target='_blank'>here</a>."
                },
                {
                    question: "Where can I find the Likewize Repair privacy policy?",
                    answer: "You'll find the Likewize Repair privacy policy <a href='/privacy' target='_blank'>here</a>."
                },
            ]
        }
    },

    computed: {
        ...mapGetters([
            "currencySymbol"
        ]),
    }
}
</script>

<style scoped>

</style>